<h6 class="mt-5 text-center mx-auto">
    <img src="assets/images/empty-state.png" alt="no-data-found" />
    <p class="mt-1 d-flex justify-content-center">{{ message | translate }}</p>
</h6>
